import { If, Notification, NotificationContent, Progress, Text, View } from '@fold-dev/core'

export const Error = ({ error }) => {
    return (
        <If if={error}>
            <View
                row
                p={10}>
                <Text
                    size="sm"
                    fontWeight={600}
                    colorToken="danger">
                    {error}
                </Text>
            </View>
            {/* 
            <Notification variant="danger">
                <NotificationContent>
                    <Text size="sm" fontWeight={600} colorToken="danger">{error}</Text>
                </NotificationContent>
            </Notification> 
            */}
        </If>
    )
}
